import store from "@/store/store.js";
import DEBUG from "@/store/debug.js";

export default async ({ commit, state }, data) => {
    DEBUG("GET_PROJECTS_START");
    if (state.projectsInit && !state.projectsLoading) {
        try {
            commit("SET_PROJECTS_LOADING", true);
            const projectsRes = await window.app.$api.getTinyCapitalIncreases({
                public: true,
                cip: false
            });
            DEBUG("GET_PROJECTS_SUCCESS");
            commit("SET_PROJECTS", projectsRes.data);
        } catch (e) {
            DEBUG("GET_PROJECTS_ERROR");
            window.app.$ui.error(e, "capital_increase_user_get_offerings");
            throw e;
        } finally {
            commit("SET_PROJECTS_LOADING", false);
        }
    } else {
        DEBUG("GET_PROJECTS_BYPASSED");
    }
};
